/* @flow */

import * as React from 'react';
import { hydrate } from 'react-dom';
import { assertObject, assertLooseObject } from '@e180/util/lib/assert';

import { containerId } from 'src/shared/app/base/constant/domConstants';

import type { Store } from 'src/shared/core/type/reduxTypes';

/**
 * Render the application client-side
 * @param   {React.ComponentType<any>} comp - Component to render
 * @param   {Store} store - Redux store
 * @param   {Object} [messages] - Translated strings
 * @returns {undefined}
 *
 * @throws Will throw an exception if parameters are not valid
 */
export default function renderApp(
  comp: React.ComponentType<any>,
  store: Store,
  messages?: Object,
): void {
  assertObject(store, 'store');
  assertLooseObject(messages, 'messages');

  const rootElt = document.querySelector(`#${containerId}`);

  if (rootElt) {
    hydrate(React.createElement(comp, { store, messages }), rootElt);
  }
}
